<template>
    <div class="sucai-page">
        <div class="SP_bj" :style="{ height: 450 + 'px' }">
            <video style="width: 100%; height: 100%; object-fit: cover;" autoplay loop muted
                src="../../assets/image/yinyue_6.mp4"></video>
        </div>
        <!-- 顶部横幅 -->
        <section class="hero">
            <div class="container">
                <div class="hero-card">
                    <h1>发现完美的音乐素材</h1>
                    <p class="sub">为您的项目提供数千个高质量的音乐片段</p>
                    <div class="hero-actions">
                        <button class="btn primary">音效素材库</button>
                    </div>
                </div>
            </div>
        </section>

        <!-- 分类切换 -->
        <section class="categories">
            <div class="container">
                <ul class="pill-list">
                    <li v-for="(c, i) in categoryList" :key="i" :class="['pill', { active: i === activeCat }]"
                        @click="TilteCilck(i, c.id)">{{ c.name }}</li>
                </ul>
            </div>
        </section>

        <!-- 热门音乐素材 -->

        <section class="hot">
            <div class="container">
                <h2>热门音乐素材</h2>
                <div class="grid">
                    <div class="card" v-for="(item, idx) in items" :key="idx">
                        <div class="top">
                            <av-waveform :audio-class="`Bofang${idx}`" :audio-controls="false" :audio-src="item.url"
                                noplayed-line-color="black" :playtime-clickable="true" :canv-width="400"></av-waveform>
                            <span class="badge">{{ item.timemusic }}s</span>
                        </div>
                        <div class="title">{{ item.name }}</div>
                        <div class="meta">{{item.singer}}</div>
                        <div class="gongNengjian" @click="Playbp(item, idx)">
                            <img v-show="!item.isPlaying" src="../../assets/image/bofang.png" alt="">
                            <img v-show="item.isPlaying" src="../../assets/image/zanting.png" alt="">
                        </div>
                        <div class="xiazai" @click="Xiazai(item, idx)">
                            <img src="../../assets/image/xiazai.png" alt="">
                        </div>
                        <div class="jiage_g">{{ item.price == 0 ? '免费' : `${item.price}硬币` }}</div>
                    </div>
                </div>
            </div>
        </section>

        <!-- <div v-show="activeCat == 0" class="jiazai_gengduo" style="padding: 10px 25px; border-radius: 50px; border: solid 1px #08a2ff; cursor: pointer;
        color: #08a2ff; margin-bottom: 30px;" @click="Gengduo()">加载更多</div> -->

    </div>
</template>
<script>
import axios from 'axios';
export default {
    name: 'sucai',
    data() {
        return {
            activeCat: 0,
            viewportHeight: 0,
            categoryList: [
                '全部素材',

                '钢琴',
                '吉他',
                '电子/合成',
                '打击乐',
                '动物叫声',
                '自然环境',
                '有趣的声音'
            ],
            items: [

            ],
            weiyiurl: '',
            yer: 2,
            scrollTimer:null
        }
    },
    mounted() {
        this.QingQiu();
        this.TilteCilck(0, 1);
        // 页面挂载后，监听 window 滚动事件（加防抖）
        window.addEventListener('scroll', this.handleScroll);
    },
    methods: {
        QingQiu() {
            axios.post('/api/index/musicsort')
                .then(res => {
                    // console.log(res.data.data)
                    this.categoryList = res.data.data;
                })
                .catch(err => {
                    console.log(err)
                })
        },
        //点击显示不同数据
        TilteCilck(i, idx) {
            this.activeCat = i;
            let data = {
                musicid: idx
            }
            axios.post('/api/index/musicdetail', data)
                .then(res => {
                    console.log(res.data.data)
                    this.items = res.data.data.map(scc => ({
                        ...scc,
                        isPlaying: false
                    }));
                })
                .catch(err => {
                    console.log(err)
                })
            this.items.forEach((otherItem, otherindex) => {
                otherItem.isPlaying = false; // 更新状态
                document.querySelector(`.Bofang${otherindex}`).pause();
                document.querySelector(`.Bofang${otherindex}`).currentTime = 0;
            });
        },
        //更多
        Gengduo() {
            let data = {
                page: this.yer,
                musicid: 1
            }
            axios.post('/api/index/musicdetail', data)
                .then(res => {
                    // console.log(res.data)
                    const Gd = res.data.data.map(scc => ({
                        ...scc,
                        isPlaying: false
                    }));
                    for (let index = 0; index < Gd.length; index++) {
                        this.items.push(Gd[index]);
                    }
                    this.yer++;
                })
                .catch(err => {
                    console.log(err)
                })
        },
        handleScroll() {
            // 防抖：300ms 内只执行一次，避免频繁触发
            clearTimeout(this.scrollTimer);
            this.scrollTimer = setTimeout(() => {
                this.checkBottom();
            }, 300);
        },

        checkBottom() {
            // 计算滚动高度（兼容所有浏览器）
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight; // 视口高度
            const scrollHeight = document.documentElement.scrollHeight; // 页面总高度

            // 触底判断：已滚动高度 + 视口高度 >= 总高度 - 10px（阈值，避免精度问题）
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                // console.log(123); // 滚动到底部打印 123
                if(this.activeCat==0){
                    this.Gengduo();
                    console.log(this.yer)
                }
            }
        },
        //播放暂停音乐
        Playbp(item, index) {
            const audioElement = document.querySelector(`.Bofang${index}`);
            // 1. 先暂停所有其他音频（避免多个同时播放）
            this.items.forEach((otherItem, otherindex) => {
                if (otherItem.isPlaying && otherindex !== index) {
                    otherItem.isPlaying = false; // 更新状态
                    document.querySelector(`.Bofang${otherindex}`).pause();
                    document.querySelector(`.Bofang${otherindex}`).currentTime = 0;
                }
            });
            console.log(item.isPlaying, '马上判断')
            if (item.isPlaying == false) {
                item.isPlaying = true;//跟新播放状态
                audioElement.play();
                // console.log('你点了播放',this.items[index].isPlaying)
            } else {
                item.isPlaying = false;//跟新播放状态
                audioElement.pause();
                audioElement.currentTime = 0;
                // console.log('你点了暂停')

            }

        },
        //下载
        Xiazai(item, index) {
            if (this.$store.state.dlMark !== null) {
                if (this.$store.state.dlMark.money >= item.price) {
                    console.log(item, index);
                    // 1. 构建 Blob 对象（指定音频格式，这里用 mp3，根据实际格式调整）
                    const blob = new Blob([item.url], { type: 'audio/mpeg' });
                    // 2. 生成临时 Blob URL
                    const blobUrl = URL.createObjectURL(blob);
                    // 创建临时 a 标签
                    const link = document.createElement('a');
                    link.href = blobUrl;
                    // 指定下载文件名（可选，默认用原文件名）
                    link.download = '中青音乐素材.mp3';
                    // 隐藏 a 标签
                    link.style.display = 'none';
                    // 添加到 DOM 并模拟点击
                    document.body.appendChild(link);
                    link.click();
                    // 下载完成后移除 a 标签（清理 DOM）
                    document.body.removeChild(link);

                    this.meYing(item.id);
                    let xzdata = {
                        yhname:this.$store.state.dlMark.username,
                        num: this.$store.state.dlMark.money-Number(item.price),
                        musicid:item.id
                    }
                    axios.post('/api/index/goumaijls',xzdata).then(res=>{
                        console.log(res);
                        
                        this.$store.state.dlMark.money = this.$store.state.dlMark.money - Number(item.price);
                        localStorage.setItem('zqW', JSON.stringify(this.$store.state.dlMark));
                    }).catch(err=>{
                        console.log(err)
                    })
                } else {
                    this.$router.push('/topUp');
                }
            } else {
                this.$message.error('您还没有登录！');
                this.$router.push('/login');
            }
        },
        //下载后保存到我的音乐
        meYing(id) {
            const data = {
                yhname:this.$store.state.dlMark.username,
                musicid:id
            }
            axios.post('/api/index/musicsc',data).then(res => {
                console.log(res.data)
                if(res.data.code!==0){
                   this.$message({
                        message: '下载成功',
                        type: 'success'
                    });

                }
            }).catch(err => {
                console.log(err)
            })
        },
         beforeUnmount() {
            // 组件卸载前移除监听，避免内存泄漏
            window.removeEventListener('scroll', this.handleScroll);
            clearTimeout(this.scrollTimer);
        }

    },


}
</script>
<style lang="scss" scoped>
.jiazai_gengduo:hover {
    color: #3f62ff !important;
    border: solid 1px #3f62ff !important;
}

.shiting_anniu {
    width: 35px;
    height: 35px;
    padding: 5px 5px;
    background-color: rgba(255, 255, 255, 0.2);
    position: absolute;
    bottom: 10px;
    font-size: 13px;
    line-height: 35px;
    cursor: pointer;
    right: 20px;
    text-align: center;
    border-radius: 50px;
}

.sucai-page {
    background: #fff;
    /* 页面白色背景 */
    color: #1f2937;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.SP_bj {
    width: 100%;
    overflow: hidden;
    object-fit: cover;
    filter: brightness(0.5);
}

.container {
    width: 1300px;
    max-width: 95%;
    margin: 0 auto;
    padding: 0 20px;
}

/* 顶部横幅（与首页风格统一：蓝紫主色） */
.hero {
    padding: 40px 0 24px;
}

.hero-card {
    background: linear-gradient(135deg, #6b7bff 0%, #7b5cf6 100%);
    color: #fff;
    border-radius: 20px;
    padding: 56px 40px;
    box-shadow: 0 18px 40px rgba(0, 0, 0, .15);

    h1 {
        font-size: 48px;
        font-weight: 800;
        margin: 0 0 16px 0;
        letter-spacing: -0.5px;
    }

    .sub {
        font-size: 18px;
        opacity: .95;
        margin-bottom: 26px;
    }

    .hero-actions {
        display: flex;
        gap: 16px;
    }

    .btn {
        padding: 12px 18px;
        border-radius: 999px;
        font-weight: 700;
        font-size: 15px;
        cursor: pointer;
        border: 1px solid transparent;
    }

    .primary {
        background: #111827;
        color: #fff;
    }

    .outline {
        background: transparent;
        color: #fff;
        border-color: rgba(255, 255, 255, .5);
    }

    .outline:hover {
        background: rgba(255, 255, 255, .08);
    }
}

/* 分类 */
.categories {
    padding: 12px 0 8px;
}

.pill-list {
    list-style: none;
    display: flex;
    gap: 14px;
    padding: 10px 0;
    margin: 0;
    flex-wrap: wrap;
}

.pill {
    padding: 8px 16px;
    border-radius: 999px;
    background: #f2f4ff;
    border: 1px solid #e3e7ff;
    color: #374151;
    cursor: pointer;
    font-weight: 600;
    transform: 0.3s;
}

.pill.active {
    background: #667eea;
    border-color: #667eea;
    color: #fff;
    transform: 0.3s;
}

.see-all {
    color: #5b6bff;
    font-weight: 600;
    margin-top: 6px;
    cursor: pointer;
}

/* 热门网格 */
.hot {
    padding: 10px 0 60px;
}

.hot h2 {
    font-size: 22px;
    margin: 8px 0 18px 0;
    font-weight: 800;
}

.grid {
    width: 1300px;
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 22px;
}

.card {
    background: #14014f;
    /* 深色卡面，呼应首页卡片反差 */
    color: #e5e7eb;
    border-radius: 16px;
    padding: 10px;
    box-shadow: 0 10px 24px rgba(0, 0, 0, .12);
    overflow: hidden;
    position: relative;

    .gongNengjian {
        width: 30px;
        height: 30px;
        cursor: pointer;
        overflow: hidden;
        border-radius: 50px;
        padding: 5px 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 100px;
        bottom: 15px;

        img {
            width: 20px;
            height: 20px;
            // margin-left: 5px;
        }

        &:hover {
            background-color: #ffffff43;
        }
    }

    .xiazai {
        width: 30px;
        height: 30px;
        cursor: pointer;
        overflow: hidden;
        border-radius: 50px;
        padding: 5px 5px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: absolute;
        right: 50px;
        bottom: 15px;

        img {
            width: 30px;
            height: 30px;
            // margin-left: 5px;
        }

        &:hover {
            background-color: #ffffff43;
        }
    }

    .jiage_g {
        width: 80px;
        height: 20px;
        background-color: #00bafd51;
        position: absolute;
        padding: 5px 20px;
        text-align: center;
        line-height: 20px;
        bottom: 4px;
        font-size: 13px;
        right: -36px;
        transform: rotate(-35deg);
    }
}

.top {
    position: relative;
    height: 94px;
    background: #d6dbe4;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.dot-row {
    position: absolute;
    width: 120px;
    height: 6px;
    background: #44ffa8;
    border-radius: 6px;
    box-shadow: 0 0 0 6px rgba(103, 232, 249, .15);
}

.badge {
    position: absolute;
    top: 8px;
    right: 8px;
    font-size: 12px;
    color: #94a3b8;
    background: #0b1220;
    border: 1px solid #1f2a44;
    padding: 2px 8px;
    border-radius: 999px;
}

.title {
    margin: 12px 0 6px;
    font-weight: 700;
    color: #f1f5f9;
}

.meta {
    font-size: 12px;
    color: #94a3b8;
}

@media (max-width: 1024px) {
    .grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media (max-width: 720px) {
    .hero-card {
        padding: 40px 22px;

        h1 {
            font-size: 34px;
        }
    }

    .grid {
        grid-template-columns: 1fr 1fr;
    }
}

@media (max-width: 480px) {
    .grid {
        grid-template-columns: 1fr;
    }
}
</style>